import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { styled, alpha, useTheme } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { translate } from '@openclassrooms/translations';
import { useChapterCancelCompletion } from '@openclassrooms/data-connect-web/chapters';
import { useChapterContext } from '../_contexts/ChapterContext';
const Wrapper = styled(Stack)(({
  theme: {
    breakpoints,
    spacing
  }
}) => ({
  padding: spacing(2),
  [breakpoints.up('sm')]: {
    padding: spacing(2, 11)
  }
}));
interface ChapterCompletionBannerProps {
  onClick: () => void;
}
const ChapterCompletionBanner = t0 => {
  const $ = _c(33);
  const {
    onClick
  } = t0;
  const router = useRouter();
  const [cancelChapterCompletion, t1] = useChapterCancelCompletion();
  const {
    isPending
  } = t1;
  const {
    currentChapter
  } = useChapterContext();
  const {
    palette
  } = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  if (!currentChapter) {
    return null;
  }
  const {
    id,
    isCompleted
  } = currentChapter;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      setAnchorEl(event.currentTarget);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleMenuClick = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAnchorEl(null);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleMenuClose = t3;
  let t4;
  if ($[2] !== cancelChapterCompletion || $[3] !== id || $[4] !== isCompleted || $[5] !== onClick || $[6] !== router) {
    t4 = () => {
      if (isCompleted && id) {
        cancelChapterCompletion(id, {
          onSuccess: () => {
            router.refresh();
            onClick();
          }
        });
      }
      handleMenuClose();
    };
    $[2] = cancelChapterCompletion;
    $[3] = id;
    $[4] = isCompleted;
    $[5] = onClick;
    $[6] = router;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleChapterCancelCompletion = t4;
  let t5;
  if ($[8] !== isCompleted || $[9] !== palette.status.info || $[10] !== palette.status.success) {
    t5 = isCompleted ? alpha(palette.status.success, 0.1) : alpha(palette.status.info, 0.1);
    $[8] = isCompleted;
    $[9] = palette.status.info;
    $[10] = palette.status.success;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const backgroundColor = t5;
  let t6;
  if ($[12] !== isCompleted) {
    t6 = isCompleted ? translate("course.chapter_status.complete") : translate("course.chapter_status.incomplete");
    $[12] = isCompleted;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const label = t6;
  let t7;
  if ($[14] !== backgroundColor) {
    t7 = {
      backgroundColor
    };
    $[14] = backgroundColor;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isCompleted || $[17] !== palette.background || $[18] !== palette.status.success) {
    t8 = isCompleted ? <CheckCircle sx={{
      mr: 1
    }} htmlColor={palette.status.success} /> : <ErrorIcon sx={{
      mr: 1
    }} htmlColor={palette.background.information} />;
    $[16] = isCompleted;
    $[17] = palette.background;
    $[18] = palette.status.success;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== label) {
    t9 = <Typography variant="subheading" component="span">{label}</Typography>;
    $[20] = label;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== anchorEl || $[23] !== handleChapterCancelCompletion || $[24] !== isCompleted || $[25] !== isPending || $[26] !== open) {
    t10 = isCompleted && <Box sx={{
      ml: "auto"
    }} data-testid="completionBannerAction"><IconButton aria-label={translate("global.word.more")} aria-controls={open ? "long-menu" : undefined} aria-expanded={open ? "true" : undefined} aria-haspopup="true" onClick={handleMenuClick} size="small" sx={{
        color: "text.primary",
        p: 0
      }}><MoreVertIcon /></IconButton><Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose} transformOrigin={{
        horizontal: "right",
        vertical: "top"
      }} anchorOrigin={{
        horizontal: "right",
        vertical: "bottom"
      }}><MenuItem onClick={handleChapterCancelCompletion} disabled={isPending}>{translate("course.chapter_status.mark_incomplete.cta")}</MenuItem></Menu></Box>;
    $[22] = anchorEl;
    $[23] = handleChapterCancelCompletion;
    $[24] = isCompleted;
    $[25] = isPending;
    $[26] = open;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t11 = <Wrapper alignItems="center" direction="row" style={t7}>{t8}{t9}{t10}</Wrapper>;
    $[28] = t10;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export default ChapterCompletionBanner;